<template>
  <!--费用设置-->
  <div class="advanced-form priceset">
    <a-form :form="form">
      <div class="card">
        <div class="card-head">
          <h3>展位价格设置</h3>
        </div>
        <div class="card-body">
          <a-form-item
            label="竖屏首页轮播"
            v-bind="$store.state.base_itemLayout">
              <a-input v-decorator="['portrait', portrait]" placeholder="请输入价格"/>
              <span class="ant-form-text">元/台/天</span>
          </a-form-item>

          <a-form-item
            label="横屏首页轮播"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['landscape', landscape]" placeholder="请输入价格"/>
            <span class="ant-form-text">元/台/天</span>
          </a-form-item>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>折扣设置</h3>
        </div>
        <div class="card-body">
          <a-form-item
            label="比例折扣"
            v-bind="$store.state.base_itemLayout">
            <a-input v-decorator="['discount', discount]" placeholder="请输入比例折扣"/>
            <span class="ant-form-text">折</span>
          </a-form-item>

          <a-form-item :wrapper-col="{ span: 8, offset: 8}">
            <a-button
              :style="{marginRight: '10px'}"
              v-for="(item, index) of toolBarList"
              :key="index"
              @click="item.handle(item)"
              :type="item.type"
              :disabled="item.authDisabled"
              :loading="item.loading && btnLoading.loading"
              size="large"
            >
              {{item.text}}
            </a-button>
          </a-form-item>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'priceSet',
  data () {
    let priceReg = /^\d+(\.\d{0,2})?$/;
    // let priceReg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;

    return {
      btnLoading: {
        loading: false
      },
      portrait: {
        initialValue: '1',
        rules: [
          {required: true, message: '请输入价格'},
          {pattern: priceReg, message: '价格为最多两位小数'}
        ]
      },
      landscape: {
        initialValue: '1',
        rules: [
          {required: true, message: '请输入价格'},
          {pattern: priceReg, message: '价格为最多两位小数'}
        ]
      },
      discount: {
        initialValue: '9',
        rules: [{pattern: /^[1-9]{1}(\.[0-9]{0,2})?$/, message: '折扣大于等于1小于10，最多两位小数'}]
      },
      toolBarList: [
        {text: '确定', handle: this.handleSubmit, type: 'primary', loading: true, key: 'confirm'},
        {text: '取消', handle: () => this.form.resetFields(), type: 'plain', key: 'cancel'}
      ]
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.getDetail();
  },
  methods: {
    getDetail () {
      this._get({
        url: '/screen_show/cost',
        params: {}
      }).then(({data}) => {
        let formData = {
          portrait: undefined,
          landscape: undefined,
          discount: undefined
        };
        Object.keys(formData).forEach((el) => {
          if (data.hasOwnProperty(el)) {
            formData[el] = data[el];
          }
        });
        this.form.setFieldsValue(formData);
      });
    },
    /** 提交表单 */
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this._put({
          url: '/screen_show/cost',
          params: values
        }).then(({data}) => {
          this.$message.success('设置成功');
          this.getDetail();
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .priceset {
    .ant-input {
      width: 70%;
    }
    .ant-form-text {
      margin-left: 8px;
      min-width: 70px;
    }
  }
</style>
